import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, AfterViewInit, OnDestroy
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import {
  MAT_DIALOG_DATA, MatDialogRef, MatSnackBar
} from '@angular/material';
import * as moment from 'moment';
import {HttpParams} from '@angular/common/http';
import {RemoveEvent} from '@progress/kendo-angular-grid';
import {UserContext} from '../../../../../services/user-context';
import {ApiService} from '../../../../../services/api';


@Component({
  selector: 'app-shopify-integration-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'shopify-integration-dialog.template.html',
  styles: [
    "app-shopify-integration-dialog mat-dialog-container {padding:0;}",
    "app-shopify-integration-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-shopify-integration-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}",
  ]
})

export class ShopifyIntegrationDialogComponent implements OnInit, OnDestroy {
  public form: FormGroup;

  integration: any;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<ShopifyIntegrationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.integration = Object.assign({url:'', token:''}, data);
    this.form = this.formBuilder.group({
      url: new FormControl(this.integration.url, [Validators.required]),
      token: new FormControl(this.integration.token, [Validators.required]),
      enabled: new FormControl(this.integration.enabled, [])
    });
  }

  public ngOnInit(): void {

  }

  public ngOnDestroy(): void {
  }

  public save() {
    this.integration = Object.assign(this.integration, this.form.value);
    this.dialogRef.close(this.integration);
  }

  public cancel() {
    this.dialogRef.close();
  }
}
